import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { useClient } from "frontend/src/domain/client";
import { AddEmployee } from "./add-client-employee";
export var ClientEmployees = function (_a) {
    var clientId = _a.clientId;
    var client = useClient(clientId).data;
    return (React.createElement(Box, null,
        React.createElement(Box, { display: "flex", justifyContent: "space-between" },
            React.createElement(Typography, { variant: "h6" }, "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438"),
            React.createElement(AddEmployee, { clientId: clientId })),
        React.createElement(Box, { mt: 1 }, (client === null || client === void 0 ? void 0 : client.employees) && (client === null || client === void 0 ? void 0 : client.employees.length) > 0 ? (React.createElement(Grid, { container: true, spacing: 3 }, client === null || client === void 0 ? void 0 : client.employees.map(function (employee) {
            var _a;
            return (React.createElement(Grid, { item: true, key: employee.id, xs: 2 },
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "caption" }, "\u041B\u043E\u0433\u0438\u043D"),
                    React.createElement(Typography, null, (_a = employee.user) === null || _a === void 0 ? void 0 : _a.name))));
        }))) : (React.createElement(Typography, null, "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E.")))));
};
